<template>
    <ion-grid class="p-0 max-height purple-purple-color">
        <ion-row class="grey4-grey4-background mb-1">
            <ion-col class="p-3 fw-b">
                {{ $t('messages.order.overview') }}
            </ion-col>
        </ion-row>

        <ion-row v-for="item of cartData.summary" :key="item.id">
            <ion-col class="px-3">
                <order-item
                    :entry="item"
                />
            </ion-col>
        </ion-row>
    </ion-grid>
</template>

<script setup lang="ts">
import { IonCol, IonGrid, IonRow } from "@ionic/vue";

import OrderItem from "@/components/various/OrderItem.vue";

import { CartData } from "@/types/supplier";
import { onActivated } from "vue";
import { useSupplierStore } from "@/stores/suppliers";
import { useI18n } from "vue-i18n";
import { replaceToast } from "@/functions/baseToast";

const props = defineProps<{ cartData: CartData }>()
const emit = defineEmits(['back'])
const { t } = useI18n()

onActivated(() => {
    if (!useSupplierStore().deliveryDays[props.cartData.supplier?.id]) {
        replaceToast({
            message: t('messages.cartDataMissing'),
            id: 'cart-data-missing'
        })
        emit('back')
    }
})
</script>
